<template lang="pug">
    div.waf-segment-builder-container
        //- 外層列表
        div.segment-row(v-for="(row, rowIndex) in value" :key="rowIndex")
            section.segment-row-container
                div.segments-row-contents
                    div.segment-row-content(v-for="field in targetFields" :key="field")
                        h4(v-if="mode === 'multiple'") {{ getRowTitle(field) }}
                        template(v-for="segment in getRowData(row, field)")
                            span {{ previewRowContent(segment) }}
                div.segment-row-icons
                    Icon.segment-row-icon(type="md-create" @click="openModal(rowIndex)")
                    Icon.segment-row-icon(type="md-trash" @click="deleteRow(rowIndex)")
        Button(@click="addRow()") {{ $t("rcmtable.addTagText") }}
        //- Modal
        Modal(v-model="showModal" :title="modalTitle" :mask-closable="false" :closable="false")
            template(v-if="localValue[editingRowIndex]")
                Builder(
                    v-for="field in targetFields"
                    :key="field"
                    :field="field"
                    :field-rule="fieldsRule[field]"
                    :title-prefix="mode === 'multiple' ? `${getRowTitle(field)} ` : ''"
                    :active-insert-index="insertIndex"
                    :active-insert-field="insertField"
                    @on-prepare="prepareInsert"
                    @on-insert="onInsert"
                    :segments="getRowData(localValue[editingRowIndex], field)"
                    @on-remove="removeSegment"
                    :show-preview-section="showBuilderPreviewSection"
                )
            //- Modal 底部按鈕
            div(slot="footer")
                Button(@click="closeModal") {{ $t('rcmtable.cancelText') }}
                Button(@click="confirmSave") {{ $t('rcmtable.confirmText') }}
</template>

<script>
import Builder from "../rcmTableFormItems/SegmentBuilder/Builder.vue";

export default {
    name: "WafSegmentBuilder",
    components: { Builder },
    props: {
        value: { type: Array, default: () => [] },
        mode: { type: String, default: "single" },
        targetFields: { type: Array, default: () => ["content"] },
        modalTitle: { type: String, default: "" },
        targetFieldsRule: { type: Object, default: () => {} },
    },
    data() {
        return {
            localValue: JSON.parse(JSON.stringify(this.value)),
            showModal: false,
            editingRowIndex: null,
            insertIndex: null,
            insertField: "",
            showBuilderPreviewSection: true,
        };
    },
    watch: {
        value(val) {
            this.localValue = JSON.parse(JSON.stringify(val));
        },
    },
    computed: {
        fieldsRule() {
            const defaultFieldsRule = Object.fromEntries(this.targetFields.map((field) => [field, {}]));
            return {
                ...defaultFieldsRule,
                ...this.targetFieldsRule,
            };
        },
    },
    methods: {
        getRowTitle(field) {
            return field.charAt(0).toUpperCase() + field.slice(1);
        },
        getRowData(row, field) {
            return this.mode === "single" ? row : row[field];
        },
        previewRowContent(segment) {
            return segment.type === "system" ? `{${segment.value}}` : segment.value;
        },
        openModal(index) {
            this.editingRowIndex = index;
            this.showModal = true;
        },
        deleteRow(index) {
            this.localValue.splice(index, 1);
            this.$emit("input", this.localValue);
        },
        addRow() {
            const newRow = this.mode === "single" ? [] : Object.fromEntries(this.targetFields.map((f) => [f, []]));
            this.localValue.push(newRow);
            this.openModal(this.localValue.length - 1);
        },
        getModalColTitle(field, suffix) {
            const prefix = this.mode === "multiple" ? `${this.getRowTitle(field)} ` : ``;
            return `${prefix}${suffix}`;
        },
        prepareInsert({ insertIndex, targetField }) {
            this.insertIndex = insertIndex;
            this.insertField = targetField;
        },
        onInsert(payload) {
            const { targetField, ...data } = payload;
            const target = this.getRowData(this.localValue[this.editingRowIndex], targetField);
            target.splice(this.insertIndex, 0, data);
        },
        removeSegment({ field, index }) {
            const target = this.getRowData(this.localValue[this.editingRowIndex], field);
            target.splice(index, 1);
        },
        closeModal() {
            this.localValue = JSON.parse(JSON.stringify(this.value));
            this.showModal = false;
            this.editingRowIndex = null;
        },
        confirmSave() {
            const row = this.localValue[this.editingRowIndex];
            const isValid = this.targetFields.every((f) => this.getRowData(row, f).length > 0);
            if (!isValid) {
                return this.$Message.error(this.$t("intelligentProtectionSettings.wafRuleModalFormValidationError"));
            }
            this.showModal = false;
            this.$emit("input", this.localValue);
        },
    },
};
</script>

<style scoped>
.waf-segment-builder-container {
    display: flex;
    flex-direction: column;
}
.segment-row {
    border-radius: 6px;
    border: 1px solid #dcdee2;
    padding: 8px 16px;
}
.segment-row-container {
    display: flex;
    align-items: center;
}
.segments-row-contents {
    flex: 1;
    min-width: 0;
}
.segment-row-content {
    word-break: break-all;
    margin-bottom: 4px;
}
.segment-row-icons {
    flex-shrink: 0;
    display: flex;
}
.segment-row-icon {
    padding: 8px;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/FormItems/WafSegmentBuilder.vue